"use strict";
var TimeoutManager = (function () {
    function TimeoutManager() {
        this._timeouts = {
            hoverdelay: null,
            popHover: null,
            scrollTimer: {},
            timeToHoverOnPop: {},
            position: null
        };
        this._handlers = {};
    }
    TimeoutManager.prototype.getTimeouts = function () {
        return this._timeouts;
    };
    TimeoutManager.prototype.getHandlers = function () {
        return this._handlers;
    };
    TimeoutManager.prototype.maybeClearTimeout = function (timeout, groupId) {
        return this._maybeClear(timeout, true, groupId);
    };
    TimeoutManager.prototype.maybeClearHandler = function (watch) {
        return this._maybeClear(watch, false, null);
    };
    TimeoutManager.prototype._maybeClear = function (timeoutOrHandler, isTimeout, groupId) {
        if (timeoutOrHandler) {
            var obj = isTimeout ? this._timeouts : this._handlers;
            var key = null;
            for (var k in obj) {
                if (obj.hasOwnProperty(k) && (obj[k] === timeoutOrHandler)) {
                    key = k;
                }
            }
            if (isTimeout) {
                if (key === 'timeToHoverOnPop' || key === 'scrollTimer') {
                    clearTimeout(obj[key][groupId]);
                }
                else {
                    clearTimeout(obj[key]);
                }
            }
            else {
                timeoutOrHandler();
            }
            if (key === 'timeToHoverOnPop' || key === 'scrollTimer') {
                obj[key][groupId] = undefined;
            }
            else {
                obj[key] = undefined;
            }
        }
    };
    return TimeoutManager;
}());
exports.TimeoutManager = TimeoutManager;
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = new TimeoutManager();
